var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDepartureTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3040_102158)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.62305 16.8248L8.5796 20.8053C8.71492 20.9875 8.95596 21.0557 9.16667 20.9714L17.2124 17.7534L27.5283 13.6424C28.3074 13.3319 29.0809 12.6983 28.9167 11.8758C28.7854 11.2183 28.2917 10.7655 27.7475 10.5432C27.2283 10.331 26.6537 10.4852 26.1277 10.6797L20.7015 12.6871C20.5433 12.7457 20.3663 12.7205 20.2307 12.6202L11.689 6.30375C11.5505 6.20131 11.3689 6.17741 11.2086 6.2405L9.84494 6.7771C9.53859 6.89765 9.43033 7.27623 9.62663 7.54051L14.7014 14.3728C14.8969 14.636 14.7905 15.013 14.4862 15.135L9.63076 17.083C9.47979 17.1435 9.3088 17.1269 9.17236 17.0383L7.19918 15.7576C7.06449 15.6701 6.89602 15.6527 6.7463 15.7107L5.84378 16.0605C5.5358 16.1798 5.42611 16.5597 5.62305 16.8248Z",
    fill: "#1B2646",
    stroke: "#1B2646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.75 26.7852H27.25",
    stroke: "#1B2646"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3040_102158"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0351562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepartureTime);
export default __webpack_public_path__ + "static/media/departure-time.2f9088c0bf68fa3697f86e2d5bc7ce7f.svg";
export { ForwardRef as ReactComponent };